import SuccessIcon from "@assets/icons/prospect-success-icon.svg";
import styled from "@emotion/styled";
import { RoundedButton } from "@ui/pages/prospect/components/rounded-button";
import React from "react";

interface ProspectSuccessMessageProps {
	title: string;
	description: string;
	buttonLabel: string;
	onButtonClick: () => void;
}

export const ProspectSuccessMessage = ({
	title,
	description,
	buttonLabel,
	onButtonClick,
}: ProspectSuccessMessageProps): JSX.Element => (
	<Container>
		<SuccessIcon width={128} height={128} />
		<MessageContainer>
			<h3>{title}</h3>
			<div>{description}</div>
		</MessageContainer>
		<RoundedButton label={buttonLabel} onClick={onButtonClick} />
	</Container>
);

const MessageContainer = styled.div`
	display: grid;
	place-items: center;
	text-align: center;
	gap: 16px;
`;

const Container = styled.div`
	display: grid;
	place-items: center;
	place-self: center;
	gap: 40px;
`;
